module.exports = __webpack_public_path__ + "static/media/32-6.a49b3114.mp3";